const splitUserName = (userName = "") => userName.split(/\s/);

export default splitUserName;
